// extracted by mini-css-extract-plugin
export default {"paye-header":"Header_paye-header__ETpbh","paye-header__buttons":"Header_paye-header__buttons__v7iiE"};